import { httpClient } from '../http/httpClient'

export const addTeamMember = async (teamId: string, memberId: string) => {
  const { data } = await httpClient.put(`/team/${teamId}/member/${memberId}`)

  return data
}
